var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 232,
    viewBox: "0 0 229 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0904 15.506L112.678 0L180.804 15.506V89.329C180.804 110.034 170.406 129.382 153.138 140.82L116.566 165.051C114.668 166.316 112.181 166.316 110.237 165.051L73.6659 140.82C56.3973 129.382 46 110.034 46 89.329V15.506H46.0904Z",
    fill: "#332FF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_85_2794",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 83,
    width: 20,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.162 111.529C137.162 111.529 131.995 96.5624 134.093 86.7335C135.146 81.7982 123.329 82.5233 121.433 87.7627C118.072 97.0513 118.802 111.523 118.802 111.523L137.162 111.529Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_85_2794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.162 111.529C137.162 111.529 131.995 96.5624 134.093 86.7335C135.146 81.7982 123.329 82.5233 121.433 87.7627C118.072 97.0513 118.802 111.523 118.802 111.523L137.162 111.529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.162 111.529C137.162 111.529 131.995 96.5624 134.093 86.7335C135.146 81.7982 123.329 82.5233 121.433 87.7627C118.072 97.0513 118.802 111.523 118.802 111.523L137.162 111.529Z",
    fill: "url(#paint0_linear_85_2794)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_85_2794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.843 76.08C138.497 77.9645 139.64 80.3788 140.041 82.5421C140.437 84.6608 140.398 86.5788 139.266 89.6454C136.922 95.0979 133.139 96.626 128.176 97.1947C125.768 97.4735 123.119 97.6129 118.581 97.6129H114.628H112.193L120.406 82.0403C120.406 82.0403 120.482 82.1574 121.748 82.0403C123.766 81.8507 125.389 80.6185 126.543 78.4162C126.794 77.9422 127.914 75.4332 128.678 73.7048C132.581 74.2233 134.928 75.4276 135.843 76.08Z",
    fill: "black",
    fillOpacity: 0.2
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_85_2794",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 68,
    width: 28,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.814 71.1741C139.468 73.0586 140.611 75.4729 141.013 77.6362C141.409 79.7549 141.37 81.6729 140.238 84.7395C137.894 90.192 134.11 91.7201 129.148 92.2888C126.739 92.5676 124.091 92.707 119.552 92.707H115.599H114.135L122.329 77.1689C121.67 77.2231 122.348 77.1344 122.348 77.1344L122.329 77.1689C122.428 77.1608 122.555 77.1496 122.719 77.1344C124.738 76.9448 126.36 75.7126 127.514 73.5103C127.765 73.0363 128.886 70.5273 129.65 68.7989C133.553 69.3174 135.9 70.5218 136.814 71.1741Z",
    fill: "#58FDC0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_85_2794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.814 71.1741C139.468 73.0586 140.611 75.4729 141.013 77.6362C141.409 79.7549 141.37 81.6729 140.238 84.7395C137.894 90.192 134.11 91.7201 129.148 92.2888C126.739 92.5676 124.091 92.707 119.552 92.707H115.599H114.135L122.329 77.1689C121.67 77.2231 122.348 77.1344 122.348 77.1344L122.329 77.1689C122.428 77.1608 122.555 77.1496 122.719 77.1344C124.738 76.9448 126.36 75.7126 127.514 73.5103C127.765 73.0363 128.886 70.5273 129.65 68.7989C133.553 69.3174 135.9 70.5218 136.814 71.1741Z",
    fill: "#58FDC0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_f_85_2794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.842 82.9969C147.117 86.002 142.796 87.1437 138.941 88.2521C138.941 88.2521 141.133 82.7103 138.941 79.0389C136.748 75.3674 129.889 74.6747 126.495 74.1898C123.683 73.7882 121.646 72.4214 121.646 72.4214C124.65 65.8771 125.031 65.008 125.031 65.008C125.031 65.008 125.052 64.9766 125.062 64.9766C127.146 65.3117 127.802 65.3326 130.563 66.0446C133.747 66.8614 136.582 68.0027 138.941 69.6466C140.189 70.5157 141.469 71.7512 142.632 73.102C143.415 74.0025 144.378 75.4684 144.886 76.4945C144.886 76.4945 146.536 79.6462 146.842 82.9969Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_85_2794",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 29,
    width: 67,
    height: 83
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.279 111.528H79.9434L140.556 29.094H145.89L101.279 111.528Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_85_2794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.279 111.528H79.9434L140.556 29.094H145.89L101.279 111.528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_85_2794)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.22,
    y: 57.2184,
    width: 23.2754,
    height: 16.4868,
    fill: "black",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_85_2794)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.796,
    y: 47.519,
    width: 23.2754,
    height: 15.517,
    fill: "black",
    fillOpacity: 0.2
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.182 67.2217C133.007 67.1604 136.904 69.0616 138.187 69.9593C141.013 71.9442 142.201 74.5034 142.658 76.7838C142.743 78.555 142.658 79.0399 142.258 80.4946C142.258 80.4946 149.254 70.266 147.765 60.2299C147.414 57.8547 146.422 55.7304 145.613 54.5149C142.039 49.1345 133.096 48.7777 133.096 48.7777L83.819 48.4431C83.3228 49.8482 83.3005 51.3982 83.3562 52.7642C83.4789 55.8419 84.4323 58.39 85.2018 59.8563C88.9876 67.0935 99.1463 67.2217 99.1463 67.2217H125.937H126.182Z",
    fill: "#58FDC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.007 67.2082L125.524 67.2082L125.524 68.663L110.007 68.663L110.007 67.2082Z",
    fill: "#332FF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8301 231.59L104.121 206.342H112.514L118.77 231.59H113.334L108.309 209.573H108.343L103.266 231.59H97.8301ZM102.343 225.744V221.607H114.309V225.744H102.343Z",
    fill: "#58FDC0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.359 232C128.536 232 126.929 231.709 125.538 231.128C124.159 230.547 123.077 229.681 122.291 228.53C121.516 227.368 121.128 225.926 121.128 224.205C121.128 224.023 121.128 223.858 121.128 223.709C121.128 223.55 121.128 223.379 121.128 223.197H126.444C126.444 223.368 126.444 223.521 126.444 223.658C126.444 223.783 126.444 223.932 126.444 224.103C126.444 225.276 126.775 226.177 127.436 226.803C128.097 227.43 129.077 227.744 130.376 227.744C131.687 227.744 132.695 227.538 133.402 227.128C134.108 226.707 134.461 226.017 134.461 225.06C134.461 224.387 134.194 223.795 133.658 223.282C133.134 222.769 132.416 222.313 131.504 221.915C130.604 221.504 129.573 221.123 128.41 220.769C127.145 220.37 125.971 219.846 124.889 219.197C123.806 218.547 122.934 217.721 122.273 216.718C121.624 215.715 121.299 214.479 121.299 213.009C121.299 211.527 121.692 210.268 122.479 209.231C123.265 208.182 124.336 207.385 125.692 206.838C127.048 206.279 128.581 206 130.291 206C132.08 206 133.658 206.279 135.026 206.838C136.405 207.385 137.481 208.211 138.256 209.316C139.043 210.41 139.436 211.778 139.436 213.419C139.436 213.601 139.436 213.772 139.436 213.932C139.436 214.08 139.436 214.251 139.436 214.444H134.137C134.137 214.319 134.137 214.188 134.137 214.051C134.137 213.915 134.137 213.783 134.137 213.658C134.137 212.553 133.829 211.704 133.214 211.111C132.61 210.519 131.658 210.222 130.359 210.222C129.105 210.222 128.131 210.45 127.436 210.906C126.752 211.362 126.41 212.063 126.41 213.009C126.41 213.692 126.655 214.274 127.145 214.752C127.647 215.231 128.33 215.658 129.197 216.034C130.063 216.41 131.048 216.786 132.154 217.162C133.658 217.687 134.969 218.268 136.085 218.906C137.214 219.533 138.085 220.325 138.701 221.282C139.316 222.228 139.624 223.436 139.624 224.906C139.624 226.41 139.236 227.692 138.461 228.752C137.687 229.812 136.598 230.621 135.197 231.179C133.806 231.726 132.194 232 130.359 232Z",
    fill: "#58FDC0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.745 222.376C163.745 223.47 163.534 224.581 163.113 225.709C162.702 226.838 162.076 227.875 161.232 228.821C160.4 229.766 159.341 230.536 158.053 231.128C156.776 231.709 155.261 232 153.506 232C151.17 232 149.175 231.447 147.523 230.342C145.87 229.225 144.606 227.687 143.728 225.726C142.862 223.766 142.429 221.516 142.429 218.974C142.429 216.433 142.862 214.188 143.728 212.239C144.606 210.291 145.87 208.764 147.523 207.658C149.175 206.553 151.17 206 153.506 206C155.455 206 157.113 206.353 158.48 207.06C159.859 207.766 160.959 208.684 161.779 209.812C162.611 210.94 163.175 212.131 163.472 213.385C163.654 214.148 163.745 214.883 163.745 215.59H158.429C158.429 215.248 158.4 214.917 158.343 214.598C158.229 213.766 157.967 213.026 157.557 212.376C157.147 211.726 156.6 211.214 155.916 210.838C155.244 210.45 154.44 210.256 153.506 210.256C152.412 210.256 151.437 210.57 150.583 211.197C149.728 211.823 149.056 212.781 148.566 214.068C148.076 215.356 147.831 216.991 147.831 218.974C147.831 220.969 148.076 222.615 148.566 223.915C149.056 225.202 149.728 226.165 150.583 226.803C151.437 227.43 152.412 227.744 153.506 227.744C154.292 227.744 154.987 227.601 155.591 227.316C156.207 227.031 156.719 226.638 157.13 226.137C157.551 225.635 157.87 225.06 158.087 224.41C158.315 223.761 158.429 223.083 158.429 222.376H163.745Z",
    fill: "#58FDC0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.158 210.479L172.551 207.949V218.393L171.355 216.889H180.654V220.991H171.355L172.551 219.487V230.017L170.158 227.487H182.551V231.59H167.218V206.376H182.551V210.479H170.158Z",
    fill: "#58FDC0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191.895 231.59H186.716V206.376H194.955L203.4 229.675L202.511 229.897V206.376H207.673V231.59H199.382L190.938 208.359L191.895 208.137V231.59Z",
    fill: "#58FDC0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M228.591 210.479H220.266L222.386 207.949V231.59H217.104V207.949L219.292 210.479H210.916V206.376H228.591V210.479Z",
    fill: "#58FDC0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 231.774V206.56H10.2222C12.8661 206.56 14.8376 207.164 16.1368 208.372C17.4473 209.569 18.1026 211.295 18.1026 213.552C18.1026 214.851 17.8519 215.962 17.3504 216.885C16.8604 217.797 16.2507 218.503 15.5214 219.005C14.8034 219.506 14.1083 219.785 13.4359 219.842C14.1311 219.888 14.7863 220.064 15.4017 220.372C16.0285 220.668 16.5413 221.141 16.9402 221.791C17.339 222.44 17.5385 223.312 17.5385 224.406C17.5385 225.215 17.5385 226.013 17.5385 226.799C17.5385 227.586 17.5385 228.389 17.5385 229.21C17.5385 229.768 17.5783 230.287 17.6581 230.765C17.7493 231.232 17.8803 231.569 18.0513 231.774H12.735C12.5869 231.546 12.4672 231.204 12.3761 230.748C12.2849 230.281 12.2393 229.768 12.2393 229.21C12.2393 228.48 12.2393 227.785 12.2393 227.124C12.2393 226.452 12.2393 225.751 12.2393 225.022C12.2393 224.03 11.9829 223.267 11.4701 222.731C10.9573 222.184 10.1368 221.911 9.00855 221.911H3.77778L5.19658 220.218V231.774H0ZM5.19658 219.74L3.77778 217.808H9.07692C9.76068 217.808 10.3704 217.654 10.906 217.346C11.4416 217.039 11.8632 216.6 12.1709 216.03C12.49 215.46 12.6496 214.794 12.6496 214.03C12.6496 212.959 12.3248 212.127 11.6752 211.534C11.037 210.942 10.1368 210.646 8.97436 210.646H3.65812L5.19658 208.919V219.74Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6562 231.774L26.9468 206.526H35.34L41.5964 231.774H36.1605L31.1349 209.757H31.1691L26.0921 231.774H20.6562ZM25.1691 225.928V221.791H37.1349V225.928H25.1691Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8542 231.774H44.5379V206.56H53.1704C55.0963 206.56 56.7431 206.936 58.1106 207.688C59.4895 208.429 60.5379 209.438 61.2559 210.714C61.9852 211.979 62.3499 213.409 62.3499 215.005C62.3499 216.589 61.9795 218.042 61.2388 219.364C60.5094 220.674 59.461 221.728 58.0935 222.526C56.726 223.312 55.0849 223.705 53.1704 223.705H49.8542V231.774ZM49.8542 222.064L47.461 219.603H52.6063C53.4952 219.603 54.2701 219.426 54.9311 219.073C55.5921 218.708 56.1049 218.184 56.4695 217.5C56.8342 216.805 57.0166 215.973 57.0166 215.005C57.0166 214.025 56.8342 213.215 56.4695 212.577C56.1163 211.928 55.6091 211.449 54.9482 211.141C54.2986 210.822 53.518 210.663 52.6063 210.663H47.461L49.8542 208.133V222.064Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6717 231.774V206.56H70.9025V231.774H65.6717Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0868 231.774V206.56H83.2406C84.9272 206.56 86.46 206.868 87.8389 207.483C89.2292 208.087 90.4201 208.948 91.4116 210.064C92.4144 211.17 93.1837 212.492 93.7193 214.03C94.2549 215.569 94.5227 217.267 94.5227 219.124C94.5227 220.982 94.2549 222.685 93.7193 224.235C93.1837 225.785 92.4144 227.124 91.4116 228.252C90.4201 229.369 89.2292 230.235 87.8389 230.851C86.46 231.466 84.9272 231.774 83.2406 231.774H75.0868ZM80.4201 230.201L78.027 227.671H82.5569C83.7876 227.671 84.8988 227.329 85.8902 226.646C86.8931 225.95 87.6851 224.965 88.2663 223.688C88.8475 222.401 89.1381 220.879 89.1381 219.124C89.1381 217.358 88.8475 215.848 88.2663 214.594C87.6851 213.329 86.8931 212.361 85.8902 211.688C84.8988 211.005 83.7876 210.663 82.5569 210.663H78.027L80.4201 208.133V230.201Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_85_2794",
    x: 110.193,
    y: 71.7048,
    width: 32.0752,
    height: 27.9081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_85_2794"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_85_2794",
    x: 120.646,
    y: 63.9766,
    width: 27.209,
    height: 25.2755,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_85_2794"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_85_2794",
    x: 101.22,
    y: 55.2184,
    width: 27.2754,
    height: 20.4868,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_85_2794"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_85_2794",
    x: 114.796,
    y: 45.519,
    width: 27.2754,
    height: 19.517,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_85_2794"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_85_2794",
    x1: 127.43,
    y1: 89.7182,
    x2: 128.426,
    y2: 104.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login-logo.de480aece4f6fdc41aa795e65c4dc093.svg";
export { ForwardRef as ReactComponent };